/**
 * Service Route Mapping Configuration
 *
 * This file maps service identifiers (from backend/permissions) to route prefixes.
 * This is used by RouteGuard to enforce service-level restrictions.
 */

export const serviceRouteMap = {
    DMT1: ['/dmt', '/moneyTransfer1'],
    DMT2: ['/dmt2', '/moneyTransfer2'],
    DMT3: ['/dmt3', '/moneyTransfer3'],
    DMT4: ['/dmt4'],
    AEPS1: ['/aeps1', '/aeps/aeps1', '/aeps1/aeps', '/aeps1/aadhaarpay'],
    AEPS2: ['/aeps2', '/aeps/aeps2', '/aeps2/aeps'],
    AEPS3: ['/aeps3', '/aeps/aeps3'],
    BBPS: ['/bbps'],
    MATM: ['/matm'],
    INSURANCE: ['/common-service/insurance2', '/common-service/insurance-list', '/common-service/insurance', '/insuranceRedirect'],
    VAS: ['/marketplace'],
    AADHARPAY: ['/aadhaarpay'],
    RECHARGE: ['/BBPS/rechargepage'],
    TRAVEL: ['/common-service/travel'],
    UPI: ['/qr'],
    CMS: ['/cmsF'],
    GOLDLOAN: ['/loan/gold-loan'],
    LOAN: ['/loan/bussiness-loan', '/loan/personal-loan', '/loan/loan-list']
};

export const serviceBaseMap = {
    DMT1: 'DMT',
    DMT2: 'DMT',
    DMT3: 'DMT',
    DMT4: 'DMT',
    AEPS1: 'AEPS',
    AEPS2: 'AEPS',
    AEPS3: 'AEPS'
};

export const defaultServiceList = Object.keys(serviceRouteMap);

/**
 * Helper to identify which service a given pathname belongs to.
 *
 * @param {string} pathname - The current URL path
 * @returns {string|null} - The service name or null if no mapping found
 */
export const identifyServiceByRoute = (pathname) => {
    if (!pathname) return null;

    // normalize: strip query, hash and trailing slashes
    const clean = pathname.split(/[?#]/)[0].replace(/\/+$/, '').toLowerCase();

    for (const [service, prefixes] of Object.entries(serviceRouteMap)) {
        if (!Array.isArray(prefixes)) continue;
        for (const prefix of prefixes) {
            if (!prefix) continue;
            // normalize prefix and check startsWith
            const p = prefix.toLowerCase().replace(/\/+$/, '');
            if (clean === p || clean.startsWith(p + '/')) {
                return service; // found a matching service
            }
        }
    }

    return null;
};
